<template>
  <BModal
    id="add-estimate-item-modal"
    ref="addEstimateItemModal"
    v-model="isVisible"
    size="lg"
    :hide-header="true"
    :hide-footer="true"
    :no-close-on-backdrop="true"
    @hidden="onModalHidden"
  >
    <BOverlay :show="overlayShow" rounded="sm">
      <!-- モーダル閉じるxボタン -->
      <BButton @click="hideModal()" aria-label="Close" class="close">
        <span aria-hidden="true">&times;</span>
      </BButton>

      <div id="est-item-search-conditions" class="p-3 mt-2 border border-dark d-inline-block rounded">
        <div id="est-project-types">
          <div class="row mb-2 ms-0 px-0 col-12">
            <h5 class="col-sm-9 pt-2 d-inline text-primary px-0">大区分</h5>
          </div>
          <div class="form-check form-check-inline px-0 me-0 col-4" v-for="(typeName, index) in projectTypes" :key="'projectType' + index">
            <BFormRadio
              :id="'estProjectType' + index"
              v-model="projectType"
              :value="typeName"
              @change="changeProjectType"
              name="estProjectType"
              data-param-name="projectType"
            >
              {{ typeName }}
            </BFormRadio>
          </div>
        </div>

        <div class="mt-5" id="est-section-s">
          <h5 class="text-primary">小区分</h5>
          <div class="d-inline" v-for="(value, index) in conditions['sectionS']" :key="'section' + index">
            <div class="form-check form-check-inline">
              <BFormRadio
                :id="'estSection' + index"
                v-model="sectionS"
                :value="value"
                @change="changeSectionS"
                name="estSectionS"
                data-param-name="sectionS"
              >
                {{ value }}
              </BFormRadio>
            </div>
          </div>
        </div>

        <div id="est-search-conditions" v-if="searchTypes.length">
          <h5 class="mt-5 text-primary">検索条件</h5>

          <div v-for="(type, index) in searchTypes" :key="'search' + index">

            <div v-if="type === 'season'">
              <div class="mt-3">
                <label class="mb-1">季節</label>
              </div>
              <div class="d-inline" v-for="(value, index) in conditions['seasons']" :key="'season' + index">
                <div class="form-check form-check-inline">
                  <BFormCheckbox
                    :id="'estSeasonCheck' + index"
                    v-model="season"
                    :value="value"
                    name="estSeason"
                    data-param-name="season"
                  >
                    {{ value }}
                  </BFormCheckbox>
                </div>
              </div>
            </div>

            <div v-if="type === 'color'">
              <div class="mt-3">
                <label class="mb-1">色</label>
              </div>
              <div class="d-inline" v-for="(value, index) in conditions['colors']" :key="'color' + index">
                <div class="form-check form-check-inline me-0 px-0 col-3">
                  <BFormCheckbox
                    :id="'estColorCheck' + index"
                    v-model="color"
                    :value="value"
                    name="estColor"
                    data-param-name="color"
                  >
                    {{ value }}
                  </BFormCheckbox>
                </div>
              </div>
            </div>

            <div v-if="type === 'shape'">
              <div class="mt-3">
                <label class="mb-1">形</label>
              </div>
              <div class="d-inline" v-for="(value, index) in conditions['shapes']" :key="'shape' + index">
                <div class="form-check form-check-inline">
                  <BFormRadio
                    :id="'estShapeCheck' + index"
                    v-model="shape"
                    :value="value"
                    name="estShape"
                    data-param-name="shape"
                  >
                    {{ value }}
                  </BFormRadio>
                </div>
              </div>
            </div>

            <div v-if="type === 'figure'">
              <div class="mt-3">
                <label class="mb-1">形態</label>
              </div>
              <div class="d-inline" v-for="(value, index) in conditions['figures']" :key="'figure' + index">
                <div class="form-check form-check-inline">
                  <BFormRadio
                    :id="'estFigureCheck' + index"
                    v-model="figure"
                    :value="value"
                    name="estFigure"
                    data-param-name="figure"
                  >
                    {{ value }}
                  </BFormRadio>
                </div>
              </div>
            </div>

            <div v-if="type === 'price'">
              <div class="mt-3">
                <label class="mb-1">価格帯</label>
              </div>
              <div class="row">
                <div class="col-5">
                  <BFormInput
                    v-model="priceFrom"
                    type="number"
                    name="estPriceFrom"
                    data-param-name="priceFrom"
                  />
                </div>
                <span class="col-1 p-0 pt-2 text-center">〜</span>
                <div class="col-5">
                  <BFormInput
                    v-model="priceTo"
                    type="number"
                    name="estPriceTo"
                    data-param-name="priceTo"
                  />
                </div>
              </div>
            </div>

            <div v-if="type === 'maker'">
              <div class="mt-3">
                <label class="mb-1">メーカー</label>
              </div>
              <BFormInput
                v-model="maker"
                type="text"
                name="estMaker"
                data-param-name="maker"
              />
            </div>

            <div v-if="type === 'flowerMaterial'">
              <div class="mt-3">
                <label class="mb-1">花材</label>
              </div>
              <BFormInput
                v-model="flowerMaterial"
                type="text"
                name="estFlowerMaterial"
                data-param-name="flowerMaterial"
              />
            </div>

          </div>
        </div>
      </div>
      <div class="mt-3 mb-5 text-center">
        <BButton variant="outline-primary" class="sub-button-color me-3" @click="search()">検索</BButton>
      </div>

      <div id="search-result-table" v-if="searchItems.length !== 0">
        <BTable :items="searchItems" :fields="tableFields" striped bordered responsive="sm" class="text-center mt-3">
          <template #cell(select)="{ item }">
            <BFormCheckbox
              v-model="selectedItems"
              :value="item.itemCode"
              name="addEstItemCode"
            />
          </template>
          <template #cell(itemPrice)="{ item }">
            {{ item.itemPrice }}
          </template>
        </BTable>
        <div class="my-3 text-center">
          <BButton class="estimate-menu-button" @click="addEstimateItem()">商品を追加</BButton>
        </div>
      </div>

    </BOverlay>
    <CommonModal ref="commonModal" />
  </BModal>
</template>
<script>
import { BModal, BOverlay, BButton, BFormRadio, BFormCheckbox, BFormInput, BTable } from 'bootstrap-vue-next'
import CommonModal from '@/components/CommonModal'
import SearchConditionsModel from '@/models/SearchConditionsModel'
import EstimateRegistModel from '@/models/EstimateRegistModel'
import SearchModel from '@/models/SearchModel'

export default {
  name: 'AddEstimateItemModal',
  components: {
    BModal,
    BOverlay,
    BButton,
    BFormRadio,
    BFormCheckbox,
    BFormInput,
    BTable,
    CommonModal
  },
  emits: ['reloadEstimate'],
  data () {
    return {
      isVisible: false,
      overlayShow: false,
      isShowItemCode: false,
      projectTypes: [],
      searchTypes: [],
      conditions: {'sectionS': {}, 'seasons': {}, 'colors': {}, 'shapes': {}, 'figures': {}},
      projectType: '',
      sectionS: '',
      season: [],
      color: [],
      shape: '',
      figure: '',
      priceFrom: '',
      priceTo: '',
      maker: '',
      flowerMaterial: '',
      searchItems: [],
      selectedItems: [],
      tableFields: [
        { key: 'select', label: '', thStyle: { width: '10%' } },
        { key: 'itemName', label: '商品名', thStyle: { width: '60%' } },
        { key: 'itemPrice', label: '商品単価(税抜)', thStyle: { width: '30%' } }
      ]
    }
  },
  methods: {
    showModal: async function () {
      this.isVisible = true

      if (localStorage.getItem('searchData') !== null) {
        this.restoreSearchConditions()
      } else {
        this.reloadProjectTypes()
      }
    },
    hideModal () {
      this.isVisible = false
    },
    onModalHidden () {
      // モーダルが閉じた後の処理
    },
    restoreSearchConditions: async function () {
      const searchData = JSON.parse(localStorage.getItem('searchData'))
      this.projectType = searchData.projectType[0]
      await this.reloadProjectTypes()

      for (const [key, value] of Object.entries(searchData)) {
        this[key] = Array.isArray(this[key]) ? value : value[0]
      }
    },
    changeProjectType () {
      this.isShowItemCode = false
      this.setSearchTypes(this.projectType)
      // 検索条件をリセット
      this.sectionS = ''
      this.season = []
      this.color = []
      this.shape = ''
      this.figure = ''
      this.priceFrom = ''
      this.priceTo = ''
      this.maker = ''
      this.flowerMaterial = ''
    },
    reloadProjectTypes: async function () {
      this.overlayShow = true
      const params = {'conditionType': 'addItem'}
      const resData = await SearchConditionsModel.apiSetStore(this.createBvModalCompat(), params, () => {
        this.overlayShow = false
      })
      const sectionL = Object.values(resData.sectionL)
      if (!this.projectType.length) {
        this.projectType = sectionL[0]
      }
      this.projectTypes = sectionL
      this.setSearchTypes(this.projectType)
    },
    setSearchTypes (projectType) {
      const store = SearchConditionsModel.getStore()
      if (!store) {
        return false
      }
      const searchTypes = ['seasons', 'colors', 'shapes', 'figures']
      for (let i = 0; i < searchTypes.length; i++) {
        this.conditions[searchTypes[i]] = store[searchTypes[i]]
      }
      this.conditions['sectionS'] = store['sectionS'][projectType]

      switch (projectType) {
        case 'メインテーブル':
        case 'ゲストテーブル':
          this.searchTypes = []
          break
        case 'コーディネート':
          this.searchTypes = ['color', 'maker']
          break
        case '演出':
          this.searchTypes = ['color', 'price', 'maker']
          break
        case 'その他装飾':
          this.searchTypes = ['price']
          break
        case '贈呈':
          this.searchTypes = ['color', 'shape', 'price']
          break
        case '挙式関係':
          this.searchTypes = []
          break
        case 'ブーケ':
          this.searchTypes = ['season', 'color', 'price', 'flowerMaterial']
          break
        case 'アフターブーケ':
          this.searchTypes = ['figure', 'maker']
          break
      }
    },
    changeSectionS () {
      this.isShowItemCode = (this.sectionS === 'プチギフト' || this.sectionS === '贈呈用ギフト')
    },
    search () {
      if (this.conditions['sectionS'] && Object.keys(this.conditions['sectionS']).length > 0) {
        this.sectionS ? this.execSearch() : this.$refs.commonModal.msgBoxOk('小区分を選択してください')
      } else {
        this.execSearch()
      }
    },
    execSearch: async function () {
      const searchData = this.createSearchData()
      localStorage.setItem('searchData', JSON.stringify(searchData))
      this.overlayShow = true
      const resData = await SearchModel.apiSetStore(this.createBvModalCompat(), searchData, () => {
        this.overlayShow = false
      })
      this.searchItems = resData['items']
      this.selectedItems = []
    },
    createBvModalCompat () {
      const cm = this.$refs.commonModal
      // refがまだ無い場合の保険も入れる
      return {
        msgBoxOk: (message, options) => {
          if (cm?.msgBoxOk) return cm.msgBoxOk(message, options)
          // 最低限のフォールバック
          alert(typeof message === 'string' ? message : String(message))
          return Promise.resolve(true)
        },
        // confirm系を使っている可能性があるなら
        msgBoxConfirm: (message, options) => {
          if (cm?.msgBoxConfirm) return cm.msgBoxConfirm(message, options)
          const ok = confirm(typeof message === 'string' ? message : String(message))
          return Promise.resolve(ok)
        }
      }
    },
    createSearchData () {
      let searchData = {}
      // プロジェクトタイプ
      if (this.projectType) {
        searchData['projectType'] = [this.projectType]
      }
      // セクション
      if (this.sectionS) {
        searchData['sectionS'] = [this.sectionS]
      }
      // 季節
      if (this.season.length) {
        searchData['season'] = this.season
      }
      // 色
      if (this.color.length) {
        searchData['color'] = this.color
      }
      // 形
      if (this.shape) {
        searchData['shape'] = [this.shape]
      }
      // 形態
      if (this.figure) {
        searchData['figure'] = [this.figure]
      }
      // 価格
      if (this.priceFrom) {
        searchData['priceFrom'] = [this.priceFrom]
      }
      if (this.priceTo) {
        searchData['priceTo'] = [this.priceTo]
      }
      // メーカー
      if (this.maker) {
        searchData['maker'] = [this.maker]
      }
      // 花材
      if (this.flowerMaterial) {
        searchData['flowerMaterial'] = [this.flowerMaterial]
      }
      return searchData
    },
    addEstimateItem: async function () {
      if (this.selectedItems.length) {
        const params = this.selectedItems.map(itemCode => ({
          'projectType': this.projectType === 'メインテーブル' || this.projectType === 'ゲストテーブル' ? 'メインテーブル・ゲストテーブル' : this.projectType,
          'itemCode': itemCode
        }))
        this.overlayShow = true
        await EstimateRegistModel.apiSetStore(this.createBvModalCompat(), params, () => {
          this.overlayShow = false
        })
        this.$emit('reloadEstimate')
        this.hideModal()
      } else {
        this.$refs.commonModal.msgBoxOk('商品を選択してください')
      }
    }
  }
}
</script>
